module.exports = __webpack_public_path__ + "img/hand_allergy.8599559f.svg";